"use strict";const e=require("./HeroBanner.js");module.exports=e;
//# sourceMappingURL=index.js.map
